const MerchantId = "16932596977";
const APIKEY = "384507";
const PublicKey = "RzAwMDA4NjgwOTB8MTY5MzI1OTY5Nzd8NGY0NjVhMWFmZDcxMTAyZWVhZWY0NWE2MjQ3Y2MyYTU1YzY3MWY5NTU1YzJhMWJiYWJhYTAzYjI3NWU5MTY0YzUzMzNhOTA1NDQxYTMzYmU2MjIzZDNlM2NjMGVkYzA2YzFkMDVlMTJlYzhkZDMzM2RkYTYyYTYxMDFmZDhjZDM=";
const ServiceTypeName = "Screening Fee";
const ServiceTypeId = "13641881481";

export { MerchantId, APIKEY, PublicKey, ServiceTypeName, ServiceTypeId };
